<template>
  <v-card
    outlined
    class="mb-5"
    min-height="250"
  >
    <v-card-text>
      <v-row no-gutters>
        <NameField
          :item="item"
          md="2"
          />

        <StatisticField
          :item="item"
          md="6"
          />

        <AdditionalField
          :item="item"
          md="3"
          />

      </v-row>

    </v-card-text>

  </v-card>
</template>

<script>
import NameField from '@/modules/display/views/elevator/elevator-statistic/NameField';
import StatisticField from "@/modules/display/views/elevator/elevator-statistic/StatisticField";
import AdditionalField from "@/modules/display/views/elevator/elevator-statistic/AdditionalField";

export default {
  name: "StatisticItem",
  components: {
    AdditionalField,
    StatisticField,
    NameField
  },
  props: {
    item: Object
  },
  data() {
    return {

    }
  }
}
</script>